import { Genres } from '@soundxyz/utils/const';

export const GENRE_DATA = [
  {
    key: Genres.HIP_HOP_RAP,
    label: Genres.HIP_HOP_RAP,
    backgroundColor: '#434D62',
    imgUrl: 'https://d16zqvkniqf1rn.cloudfront.net/explore/v1/HIP_HOP_RAP.png',
  },
  {
    key: Genres.ELECTRONIC,
    label: Genres.ELECTRONIC,
    backgroundColor: '#30AEAD',
    imgUrl: 'https://d16zqvkniqf1rn.cloudfront.net/explore/v1/ELECTRONIC.png',
  },
  {
    key: Genres.POP,
    label: Genres.POP,
    backgroundColor: '#C03A62',
    imgUrl: 'https://d16zqvkniqf1rn.cloudfront.net/explore/v1/POP.png',
  },
  {
    key: Genres.R_B_SOUL,
    label: Genres.R_B_SOUL,
    backgroundColor: '#1B67AC',
    imgUrl: 'https://d16zqvkniqf1rn.cloudfront.net/explore/v1/R_B_SOUL.png',
  },
  {
    key: Genres.INDIE,
    label: Genres.INDIE,
    backgroundColor: '#C17D56',
    imgUrl: 'https://d16zqvkniqf1rn.cloudfront.net/explore/v1/INDIE.png',
  },
  {
    key: Genres.DANCE_EDM,
    label: Genres.DANCE_EDM,
    backgroundColor: '#5B509E',
    imgUrl: 'https://d16zqvkniqf1rn.cloudfront.net/explore/v1/DANCE_EDM.png',
  },
  {
    key: Genres.ALTERNATIVE_ROCK,
    label: Genres.ALTERNATIVE_ROCK,
    backgroundColor: '#56AEC4',
    imgUrl: 'https://d16zqvkniqf1rn.cloudfront.net/explore/v1/ALTERNATIVE_ROCK.png',
  },
  {
    key: Genres.EXPERIMENTAL,
    label: Genres.EXPERIMENTAL,
    backgroundColor: '#B56B89',
    imgUrl: 'https://d16zqvkniqf1rn.cloudfront.net/explore/v1/EXPERIMENTAL.png',
  },
  {
    key: Genres.AMBIENT,
    label: Genres.AMBIENT,
    backgroundColor: '#8D4083',
    imgUrl: 'https://d16zqvkniqf1rn.cloudfront.net/explore/v1/AMBIENT.png',
  },
  {
    key: Genres.FOLK_SINGER_SONGWRITER,
    label: 'Singer-Songwriter',
    backgroundColor: '#897E76',
    imgUrl: 'https://d16zqvkniqf1rn.cloudfront.net/explore/v1/SINGER_SONGWRITER.png',
  },
  {
    key: Genres.HOUSE,
    label: Genres.HOUSE,
    backgroundColor: '#9954A9',
    imgUrl: 'https://d16zqvkniqf1rn.cloudfront.net/explore/v1/HOUSE.png',
  },
  {
    key: Genres.TECHNO,
    label: Genres.TECHNO,
    backgroundColor: '#404040',
    imgUrl: 'https://d16zqvkniqf1rn.cloudfront.net/explore/v1/TECHNO.png',
  },
  {
    key: Genres.COUNTRY,
    label: Genres.COUNTRY,
    backgroundColor: '#863719',
    imgUrl: 'https://d16zqvkniqf1rn.cloudfront.net/explore/v1/COUNTRY.png',
  },
  {
    key: Genres.ROCK,
    label: Genres.ROCK,
    backgroundColor: '#809DB1',
    imgUrl: 'https://d16zqvkniqf1rn.cloudfront.net/explore/v1/ROCK.png',
  },
  {
    key: Genres.TRAP,
    label: Genres.TRAP,
    backgroundColor: '#444444',
    imgUrl: 'https://d16zqvkniqf1rn.cloudfront.net/explore/v1/TRAP.png',
  },
  {
    key: Genres.LATIN,
    label: Genres.LATIN,
    backgroundColor: '#E85C40',
    imgUrl: 'https://d16zqvkniqf1rn.cloudfront.net/explore/v1/LATIN.png',
  },
  {
    key: Genres.WORLD,
    label: Genres.WORLD,
    backgroundColor: '#B68734',
    imgUrl: 'https://d16zqvkniqf1rn.cloudfront.net/explore/v1/WORLD.png',
  },
  {
    key: Genres.DRUM_BASS,
    label: Genres.DRUM_BASS,
    backgroundColor: '#39656F',
    imgUrl: 'https://d16zqvkniqf1rn.cloudfront.net/explore/v1/DRUM_BASS.png',
  },
];
